import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import AppLayout from './components/layout/AppLayout';
import AdminLayout from './components/layout/AdminLayout';
import LoginPage from './pages/LoginPage';
import ChatPage from './pages/ChatPage';
import { ProtectedRoute } from './components/auth/ProtectedRoute';
import { RootRedirect } from './components/auth/RootRedirect';
import { RequireAdminRole } from './components/auth/RequireAdminRole';
import UsagePage from './pages/admin/UsagePage';

function App() {
  return (
    <BrowserRouter basename={import.meta.env.BASE_URL}>
      <Routes>
        {/* Login page - no layout (no sidebar) */}
        <Route path="/login" element={<LoginPage />} />

        {/* Root redirect - decides where to send users based on auth status */}
        <Route path="/" element={<RootRedirect />} />

        {/* Chat routes - with AppLayout (sidebar) and protected */}
        <Route element={<AppLayout />}>
          <Route
            path="chat"
            element={
              <ProtectedRoute>
                <ChatPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="chat/:conversationId"
            element={
              <ProtectedRoute>
                <ChatPage />
              </ProtectedRoute>
            }
          />
        </Route>

        {/* Admin routes - with AdminLayout (simplified sidebar, no chat controls) */}
        <Route element={<AdminLayout />}>
          <Route
            path="admin/usage"
            element={
              <ProtectedRoute>
                <RequireAdminRole>
                  <UsagePage />
                </RequireAdminRole>
              </ProtectedRoute>
            }
          />
        </Route>

        {/* Catch-all redirect to root */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      <ReactQueryDevtools initialIsOpen={false} />
    </BrowserRouter>
  );
}

export default App;
